import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import api from '../../services/bookingApi'; // Ajuster le chemin selon le fichier
import '../BookingCalendar.css'; // Import custom CSS

// Configurer le localizer
moment.locale('fr');
const localizer = momentLocalizer(moment);

const BookingCalendar = ({ appointments: propAppointments, onSelectEvent: propOnSelectEvent, onSelectSlot, style }) => {
  const [localAppointments, setLocalAppointments] = useState([]);
  const [loading, setLoading] = useState(false);

  // Si des appointments sont passés en props, on les utilise, sinon on utilise le state local
  const appointments = propAppointments || localAppointments;

  useEffect(() => {
    // Si aucune prop appointments n'est passée, on charge les données
    if (!propAppointments) {
      loadData();
    }
  }, [propAppointments]);

  const loadData = async () => {
    setLoading(true);
    try {
      const userLocation = localStorage.getItem('userLocation');

      console.log('🔍 BookingCalendar - userLocation:', userLocation);

      const filters = userLocation ? { location: userLocation } : {};

      console.log('🔍 BookingCalendar - Filters envoyés:', filters);

      const data = await api.getAppointments(filters);

      console.log('📊 BookingCalendar - Appointments reçus:', data.length, data);

      setLocalAppointments(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Erreur chargement calendrier:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectEvent = (event) => {
    if (propOnSelectEvent) {
      propOnSelectEvent(event.resource);
    } else {
      // Comportement par défaut si pas de handler parent
      const app = event.resource;
      alert(`Client: ${app.clientName}\nService: ${app.services?.map(s => s.name).join(', ')}\nDate: ${moment(app.date).format('DD/MM/YYYY')} ${app.startTime}`);
    }
  };

  // Transformer les rendez-vous au format attendu par le calendrier
  const events = (Array.isArray(appointments) ? appointments : []).map(app => {
    // Calcul de la date de fin si pas présente
    let start = new Date(app.date); // Date de base

    // Si startTime est présent (ex: "14:30"), l'ajouter à la date
    if (app.startTime) {
      const [hours, minutes] = app.startTime.split(':').map(Number);
      start.setHours(hours, minutes, 0, 0);
    }

    let end = new Date(start);
    if (app.endTime) {
      const [endHours, endMinutes] = app.endTime.split(':').map(Number);
      end.setHours(endHours, endMinutes, 0, 0);
    } else {
      // Défaut : +duration minutes ou +1h
      const duration = app.duration || 60;
      end = new Date(start.getTime() + duration * 60000);
    }

    return {
      id: app._id,
      title: `${app.clientName} - ${app.services?.map(s => s.name).join(', ') || app.service?.name || 'RDV'}`,
      start,
      end,
      resource: app,
      // Couleur selon le statut et le conflit
      color: app.isConflict ? '#9c27b0' : // Purple for conflicts
        app.status === 'confirmed' ? '#28a745' :
          app.status === 'cancelled' ? '#dc3545' : '#ffc107'
    };
  });

  const eventStyleGetter = (event, start, end, isSelected) => {
    const style = {
      backgroundColor: event.color,
      borderRadius: '5px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block'
    };
    return {
      style: style
    };
  };

  // Style des cases vides (optionnel, pour faire "tableau")
  const slotPropGetter = () => ({
    style: {
      backgroundColor: 'rgba(255, 0, 0, 0.03)',
    }
  });

  if (loading) return <div className="booking-calendar-wrapper">Chargement du calendrier...</div>;

  return (
    <div className="booking-calendar-wrapper" style={style}>
      <div className="booking-calendar-container">
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: '100%' }}
          views={['month', 'week', 'day', 'agenda']}
          length={90} // Afficher les 90 prochains jours dans la vue Agenda (3 mois)
          messages={{
            next: "Suivant",
            previous: "Précédent",
            today: "Aujourd'hui",
            month: "Mois",
            week: "Semaine",
            day: "Jour",
            agenda: "Agenda",
            date: "Date",
            time: "Heure",
            event: "Événement",
            noEventsInRange: "Aucun rendez-vous dans cette période.",
            showMore: total => `+ ${total} rendez-vous supplémentaire(s)`
          }}
          defaultView="week"
          min={new Date(0, 0, 0, 8, 0, 0)} // Début à 8h00
          max={new Date(0, 0, 0, 22, 0, 0)} // Fin à 22h00
          eventPropGetter={eventStyleGetter}
          slotPropGetter={slotPropGetter}
          onSelectEvent={handleSelectEvent}
          onSelectSlot={onSelectSlot}
          selectable
        />
      </div>
    </div>
  );
};

export default BookingCalendar;